<template lang="html">
  <div class="card">
   <slot></slot>
  </div>

  </div>
</template>
<script>
export default {};
</script>

<style lang="scss">
.card {
  border: none !important;
  background: #312626;
  position: relative;
  display: block;
  // flex-direction: column;
  background-color: #fff;
  border-radius: 30px;
  margin-bottom: 30px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/parts/components/login.vue